import { render, staticRenderFns } from "./ControleDesmatamentoAmazoniaConsolidada.vue?vue&type=template&id=101a60d9&scoped=true&lang=pug"
import script from "./ControleDesmatamentoAmazoniaConsolidada.vue?vue&type=script&lang=js"
export * from "./ControleDesmatamentoAmazoniaConsolidada.vue?vue&type=script&lang=js"
import style0 from "./ControleDesmatamentoAmazoniaConsolidada.vue?vue&type=style&index=0&id=101a60d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101a60d9",
  null
  
)

export default component.exports